import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import SEO from '../components/SEO';
import QuoteSection from '../components/QuoteSection';
import LightboxModal from '../components/LightboxModal';
import { imageUrl } from '../lib/images';

export default function GalleryPage() {
  const { type } = useParams();
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const galleryData = {
    panelhegn: {
      title: "Panelhegn | Hovendals",
      heading: "Galleri: Panelhegn",
      desc: "Se vores udvalg og tidligere udførte projekter med panelhegn til private og erhverv i hele Danmark.",
      category: "Panelhegn",
      parentLink: "/panelhegn",
      parentLabel: "Læs om panelhegn",
      images: [
        { src: "/_assets/490153135-1329555835199280-767963427889470727-n-0.jpg", title: "Panelhegn" },
        { src: "/_assets/panelhegn2.jpeg", title: "Panelhegn sort" },
        { src: "/_assets/panelhegn5-1.jpeg", title: "Panelhegn i have" },
        { src: "/_assets/panelhegn4-1.jpeg", title: "Panelhegn i Odense" },
        { src: "/_assets/panelhegn3.jpeg", title: "Panelhegn i Danmark" },
        { src: "/_assets/327032265-938137584260657-5283060228493626441-n.jpg", title: "Panelhegn i Aalborg" },
        { src: "/_assets/333571161-1143977852939452-4405149958717881853-n.jpg", title: "Panelhegn i Gentofte" },
        { src: "/_assets/thumbnail-1000003866.jpg", title: "Panelhegn erhverv" },
        { src: "/_assets/thumbnail-1000003902.jpg", title: "Panelhegn virksomheder" },
        { src: "/_assets/thumbnail-1000003903.jpg", title: "Panelhegn virksomhed" },
        { src: "/_assets/thumbnail-img20250219132431.jpg", title: "Panelhegn" },
        { src: "/_assets/1000003297.jpg", title: "Panelhegn" },
        { src: "/_assets/thumbnail-1000003459.jpg", title: "Panelhegn Hovendals" },
        { src: "/_assets/thumbnail-1000003512.jpg", title: "Panelhegn på landet" },
      ]
    },
    panellaage: {
      title: "Panellåge | Hovendals",
      heading: "Galleri: Panellåger",
      desc: "Se eksempler på skræddersyede panellåger til haven, indkørslen eller erhvervsarealet.",
      category: "Panellåge",
      parentLink: "/panellaage",
      parentLabel: "Læs om panellåger",
      images: [
        { src: "/_assets/333571161-1143977852939452-4405149958717881853-n-2.jpg", title: "Panellåge" },
        { src: "/_assets/thumbnail-1000003507.jpg", title: "Panellåge" },
        { src: "/_assets/thumbnail-1000003516.jpg", title: "Panellåge" },
        { src: "/_assets/thumbnail-img20240508122959.jpg", title: "Panellåge" },
        { src: "/_assets/thumbnail-img20250430120431.jpg", title: "Panellåge" },
      ]
    },
    skur: {
      title: "Skur | Hovendals",
      heading: "Galleri: Skure",
      desc: "Se vores skure og redskabsrum i robuste materialer kombineret med carporte og terrasser.",
      category: "Skur",
      parentLink: "/skur",
      parentLabel: "Læs om skure",
      images: [
        { src: "/_assets/295322415-584214203079039-442631182103604215-n-0.jpg", title: "Skur" },
        { src: "/_assets/thumbnail-1000004142-0.jpg", title: "Skur" },
        { src: "/_assets/thumbnail-1000004145-0_fe8d348a.jpg", title: "Skur" },
        { src: "/_assets/thumbnail-img20250813095918-0.jpg", title: "Skur" },
        { src: "/_assets/thumbnail-img20250813100319-0.jpg", title: "Skur" },
        { src: "/_assets/thumbnail-img20250813100327-0.jpg", title: "Skur" },
      ]
    },
  };

  const current = galleryData[type] || galleryData.panelhegn;

  return (
    <>
      <SEO
        title={current.title}
        description={current.desc}
        ogImage={current.images[0]?.src}
      />

      {/* Hero */}
      <section className="relative py-20 bg-slate-900 text-white overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-20">
          <img
            src={imageUrl(current.images[0]?.src, "width=1600,quality=80,format=auto")}
            alt={current.heading}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl space-y-4">
            <div className="flex items-center gap-3">
              <Link
                to="/referencer"
                className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#c2ccdf] hover:text-[#c2ccdf]"
              >
                <i className="fa-sharp fa-solid fa-arrow-left text-xs" aria-hidden="true"></i>
                <span>Alle referencer</span>
              </Link>
              <span className="text-slate-600">/</span>
              <Link
                to={current.parentLink}
                className="text-xs font-semibold text-slate-300 hover:text-white"
              >
                {current.parentLabel}
              </Link>
            </div>

            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-tight">
              {current.heading}
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed font-normal">
              {current.desc}
            </p>
          </div>
        </div>
      </section>

      {/* Gallery */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between gap-4 mb-8 pb-4 border-b border-slate-100">
            <div>
              <span className="text-xs font-bold uppercase tracking-wider text-[#004fa4]">Fotos</span>
              <h2 className="text-2xl font-bold text-slate-900 mt-0.5">
                {current.images.length} fotos i galleriet
              </h2>
            </div>
            <Link
              to={current.parentLink}
              className="inline-flex items-center gap-2 text-sm font-bold text-[#004fa4] hover:text-[#183e7f] transition-colors"
            >
              <span>{current.parentLabel}</span>
              <i className="fa-sharp fa-solid fa-arrow-right text-xs" aria-hidden="true"></i>
            </Link>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
            {current.images.map((item, idx) => (
              <div
                key={idx}
                onClick={() => setLightboxIndex(idx)}
                className="group relative h-48 sm:h-60 rounded-xl overflow-hidden bg-slate-100 cursor-pointer shadow-sm hover:shadow-lg transition-all"
              >
                <img
                  src={imageUrl(item.src, "width=500,quality=80,format=auto")}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-slate-950/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center text-white">
                  <span className="p-3 rounded-full bg-[#143463]/90 text-white">
                    <i className="fa-sharp fa-solid fa-magnifying-glass-plus text-lg" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <QuoteSection />

      {/* Lightbox Modal */}
      <LightboxModal
        images={current.images}
        currentIndex={lightboxIndex}
        onClose={() => setLightboxIndex(null)}
        onNavigate={(index) => setLightboxIndex(index)}
      />
    </>
  );
}
